var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreIconLs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 9,
    viewBox: "0 0 21 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8507 0.988281H11.651C9.20712 0.988281 8.10381 2.59286 8.10381 3.73235C8.10381 4.87183 9.04103 5.75551 11.4731 5.75551H11.9713C12.5052 5.75551 12.8018 5.82528 12.8136 6.18573C12.8136 6.38339 12.6831 6.60431 12.5408 6.70896C12.2086 6.95313 11.9239 6.98802 10.3935 6.98802H2.80081L4.27188 0.999909H1.73309C1.567 0.999909 1.49582 1.04642 1.44836 1.24408L0.0603296 6.86012C-0.200668 7.97634 0.392509 8.99956 1.6975 8.99956H5.17351C6.05142 8.99956 7.23777 8.05774 7.71231 7.18568C7.73604 7.13917 7.75976 7.10429 7.77163 7.06941C7.77163 7.06941 7.78349 7.05778 7.78349 7.06941C7.71231 7.38335 7.45131 8.48795 7.40386 8.67399C7.34454 8.90654 7.47504 8.99956 7.59368 8.99956H11.3307C14.4983 8.99956 15.7439 7.52288 15.8507 5.74389C15.91 4.74393 15.2694 4.10442 13.4424 4.10442H12.0425C11.5442 4.10442 11.0341 3.94164 11.0341 3.54631C11.0341 3.15098 11.5917 2.80215 12.3391 2.80215H15.7439C15.7439 2.80215 16.0405 1.62779 16.0998 1.38361C16.1829 1.0813 16.088 0.988281 15.8507 0.988281Z",
    fill: "#003378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9192 1.75574L20.3952 0H13.6211C13.6211 0 16.5514 0.58137 16.8124 0.639507C17.0734 0.686016 17.1327 0.825545 17.0852 1.01158C17.0497 1.17437 16.9192 1.75574 16.9192 1.75574Z",
    fill: "#E6003E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreIconLs);
export default __webpack_public_path__ + "static/media/store_icon_ls.7ef9d37af6121748269c534392e0de94.svg";
export { ForwardRef as ReactComponent };